import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/right.png";

const DeleteAlertPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const message =
    location.state?.message || "Account Deleted Successfully";

  return (
    <div className="logout-alert-container">
      <div className="logout-alert-content">
        <img src={logo} alt="Success" className="logo" />
        <h2>{message}</h2>

        <button
          className="custom-next-button"
          onClick={() => navigate("/")}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default DeleteAlertPage;
